import { Component, input, output } from '@angular/core';
import { ToastType } from '../../../services/toast.service';

/**
 * One toast, drawn.
 *
 * Presentational only — it does not know about `ToastService`, does not
 * position itself and does not time itself out. The app shell owns the single
 * global instance and where it sits; keeping placement out of here is what
 * would let a screen stack its own toast somewhere else without fighting a
 * `fixed` rule baked into the component.
 */
@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  /* See the note on StatStripComponent — an inline host drops vertical margins. */
  styles: [':host { display: block }'],
})
export class ToastComponent {
  kind = input.required<ToastType>();
  message = input.required<string>();
  dismiss = output<void>();
}
